module.exports = __webpack_public_path__ + "img/gcoin_galaxycoins1.9438ec2.png";